import { AlertProps } from '../../types';

export default (props: AlertProps) => {
    const { type } = props;
    const { duration } = props.alert;
    if(duration > 0) {
        const unit = type === "response" ? "secs response" : "mins transfer";
        return `${duration} ${unit} time`;
    } else if(type === "transfer") {
        return 'File could not be transmitted by FTP';
    } else {
        return 'Invalid alert';
    }
}



// WEBPACK FOOTER //
// ./src/components/Alert/setAlertSecondaryText.ts